import React, { Component, Fragment } from 'react';

import ErrorDialog from '../content/dialogs/ErrorDialog';

import { getDisplayName } from './common';

function withRequestHandler(WrappedComponent) {
  class WithRequestHandler extends Component {
    constructor(props) {
      super(props);

      this.state = {
        isLoading: false,
        error: null,
        showErrorDialog: false,
        showLoadingDialog: false,
      };

      this.handleRequestStart = this.handleRequestStart.bind(this);
      this.handleRequestStop = this.handleRequestStop.bind(this);
      this.handleRequestError = this.handleRequestError.bind(this);
    }

    handleRequestStart() {
      // Only update state if necessary
      if (!this.state.isLoading) {
        this.setState({ isLoading: true });
      }
    }

    handleRequestStop() {
      // Only update state if necessary
      if (this.state.isLoading) {
        this.setState({ isLoading: false });
      }
    }

    handleRequestError(error) {
      this.setState({ isLoading: false, showErrorDialog: true, error });
    }

    render() {
      const { isLoading, error, showErrorDialog } = this.state;
      return (
        <Fragment>
          <WrappedComponent
            isLoading={isLoading}
            onRequestStart={this.handleRequestStart}
            onRequestStop={this.handleRequestStop}
            onRequestError={this.handleRequestError}
            {...this.props}
          />
          <ErrorDialog
            open={showErrorDialog}
            error={error}
            onRequestClose={() => this.setState({ showErrorDialog: false, error: null })}
          />
        </Fragment>
      );
    }
  }

  WithRequestHandler.displayName = `WithRequestHandler(${getDisplayName(
    WrappedComponent,
  )})`;

  return WithRequestHandler;
}

export default withRequestHandler;
